import { Typography } from '@mui/material';
import React from 'react';
export const DragTargetPlaceholder = (props) => {
    return (React.createElement(Typography, { "data-drag-target-placeholder": true, sx: { p: '7px', border: '2px dashed rgba(0, 0, 0, 0.1)', color: 'text.disabled' } }, props.children));
};
